import { useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

import type { AggregatePortfolioQueryClientData } from '@/hooks/portfolio/useAggregatePortfolio';
import {
  AGGREGATE_PORTFOLIO_FRAGMENT,
  AGGREGATE_PORTFOLIO_QUERY_KEY,
} from '@/hooks/portfolio/useAggregatePortfolio';

const MUTATION = gql(
  `
    mutation updateAggregatePortfolioBenchmark(
        $benchmark: String!
        $benchmarkType: BenchmarkType!
    ) {
        updateAggregatePortfolioBenchmark(
            benchmark: $benchmark
            benchmarkType: $benchmarkType
        ) {
            ...aggregatePortfolioFields
        }
    }
`,
  [AGGREGATE_PORTFOLIO_FRAGMENT]
);

const mutation = makeGqlMutation(MUTATION);

export const useUpdateAggregatePortfolioBenchmark = () => {
  const queryClient = useQueryClient();

  return mutation({
    onMutate: (payload) => {
      queryClient.setQueriesData<AggregatePortfolioQueryClientData>(
        {
          queryKey: AGGREGATE_PORTFOLIO_QUERY_KEY,
        },
        (state) =>
          produce(state, (draft) => {
            if (typeof draft === 'undefined') {
              return draft;
            }
            draft.analysis.benchmark = payload.benchmark;
            draft.analysis.benchmarkType = payload.benchmarkType;
          })
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [AGGREGATE_PORTFOLIO_QUERY_KEY],
      });
    },
  });
};
